// extracted by mini-css-extract-plugin
module.exports = {"createRoomContainer":"createroom_createRoomContainer__lN5s5","brandCreateRoom":"createroom_brandCreateRoom__bNKky","error":"createroom_error__X4yTS"};